<ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
  [spinner]="spinkit.skThreeBounce">
</ng-http-loader>


<div>
  <div class="container-fluid">
    <div class=" d-flex" style="margin-top: 7%;padding-left: 13px;">
      <div class="">
        <img src="../../../../assets/img/backMenu.svg" alt="" (click)="backToFoodMenu()" style="cursor: pointer;">
      </div>
      <div class="restoName ">
        Choose Your Food Preferences
      </div>
    </div>
  </div>
  <div class="container" *ngIf="!hideSpiceTollrace">
    <div class=" choose-alleregens-text col-12 pad-bottom-10">
      Select spice tolerance
    </div>
  </div>
  <div class="container-fluid"  *ngIf="!hideSpiceTollrace">
    <div class="container-fluid marg-t8 custom-slider">
      <ng5-slider [(value)]="spiceTollerence" [options]="options"></ng5-slider>
    </div>
  </div>
</div>

<div class="container">
  <div>
    <div class=" choose-alleregens-text col-12 ">
      Choose your allergens
    </div>
  </div>

  <div class="row row-class">
    <div class="preferences col-4">
      <button [ngClass]="statusClasses" (click)="AllergensRemove()">None</button>
    </div>
    <div class="col-4 preferences" *ngFor="let item of allAllergensArray; index as i">
      <div *ngIf="i< 8 || More">
        <ng-container *ngIf="allergenceArray.includes(item.allergens_id)">
          <button class="buttons-green"
            (click)="toggleSelectedAllergence(item.allergens_id,item.allergens_name,i);setAllergenceActiveClass()"
            id="btn_{{item.allergens_name}}">{{item.allergens_name}} </button>
        </ng-container>
        <ng-container *ngIf="!allergenceArray.includes(item.allergens_id)">
          <button class="buttons"
            (click)="toggleSelectedAllergence(item.allergens_id,item.allergens_name,i);setAllergenceActiveClass()"
            id="btn_{{item.allergens_name}}">{{item.allergens_name}} </button>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="container" *ngIf="allAllergensArray.length > 8">
    <button class="moreTitle" (click)="More = !More">{{ More ? 'Less':'More' }}</button>
  </div>
</div>

<div class="container">
  <div>
    <div class="choose-alleregens-text col-12">
      Choose your dietary preferences
    </div>

    <div class="row row-class">
      <div class="col-4 preferences">
        <button [ngClass]="statusClass" (click)="dietRemove()">None</button>
      </div>
      <div class="col-4 preferences" *ngFor="let item of alldietary; index as i">
        <div *ngIf="i< 8 || more">
          <ng-container *ngIf="diestPrefArray.includes(item.diet_preference_id)">
            <button class="buttons-green"
              (click)="addAllDiet(item.diet_preference_id,item.diet_preference_name,i);setActiveClass()"
              id="btn_{{item.diet_preference_name}}">{{item.diet_preference_name}} </button>
          </ng-container>
          <ng-container *ngIf="!diestPrefArray.includes(item.diet_preference_id)">
            <button class="buttons"
              (click)="addAllDiet(item.diet_preference_id,item.diet_preference_name,i);setActiveClass()"
              id="btn_{{item.diet_preference_name}}">{{item.diet_preference_name}} </button>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="container" *ngIf="alldietary.length > 8">
      <button class="moreTitle" (click)="more = !more">{{ more ? 'Less':'more' }}</button>
    </div>
  </div>
</div>


<div class="container">
  <button class="btn-update" type="submit" (click)="updateUserPreferences()">Show Menu</button>
</div>